import { inject, Injectable } from '@angular/core';
import { DepartmentDisplay } from '@modules/department/models/department-display';
import { Store } from '@ngrx/store';
import { Client } from '@pixacare/domain';
import { combineLatest, first, Observable, switchMap } from 'rxjs';
import { selectClient } from 'src/app/shared/store/clients/clients.selectors';
import { departmentsActions } from 'src/app/shared/store/departments/departments.actions';
import { selectClientDepartment } from 'src/app/shared/store/departments/departments.selectors';
import { selectClientCode, selectDepartmentId } from 'src/app/shared/store/router/router.selectors';
import { DepartmentAdminParams } from '../../../administration/models/department-admin-params';

@Injectable()
export class DepartmentAdminService {
  private readonly store = inject(Store);

  readonly params$: Observable<DepartmentAdminParams> = combineLatest({
    clientCode: this.store.select(selectClientCode),
    departmentId: this.store.select(selectDepartmentId),
  });

  readonly department$: Observable<DepartmentDisplay> = this.params$.pipe(
    switchMap(({ clientCode, departmentId }) => this.store.select(selectClientDepartment(clientCode, departmentId))),
  );

  readonly client$: Observable<Client> = this.params$.pipe(
    switchMap(({ clientCode }) => this.store.select(selectClient(clientCode))),
  );

  updateDepartment({
    name,
    isOpen,
    medicalSpecialtyId,
  }: {
    name?: string;
    isOpen?: boolean;
    medicalSpecialtyId?: number;
  }): void {
    this.params$.pipe(first()).subscribe({
      next: ({ clientCode, departmentId }) => {
        this.store.dispatch(
          departmentsActions.updateDepartment({
            clientCode,
            departmentId,
            name,
            isOpen,
            medicalSpecialtyId,
          }),
        );
      },
    });
  }
}
